export default __webpack_public_path__ + "static/media/supported-payments.ee404605.png";